// Codenames are drawn from two fixed word lists, shared by browser and server.
// The server only accepts names built from these lists, so nobody can choose
// an offensive or impersonating name. When a name is taken, members get a
// numbered successor: "Silent Perigee II", "Silent Perigee III", ...

export const FIRST = [
  "Silent", "Amber", "Northern", "Low", "Pale", "Distant", "Patient", "Quiet",
  "Iron", "Midnight", "Hollow", "Bright", "Slow", "Second", "Cold", "Sodium",
  "Copper", "Silver", "Late", "Early", "Polar", "Western", "Eastern", "Southern",
  "Still", "Faint", "Steady", "Lone", "Wandering", "Grey", "Blue", "Frozen",
  "Hidden", "Narrow", "Long", "Old", "Fading", "Rising", "Last", "Clear",
];

export const SECOND = [
  "Perigee", "Node", "Meridian", "Zenith", "Umbra", "Azimuth", "Transit", "Horizon",
  "Orbit", "Twilight", "Apogee", "Beacon", "Lantern", "Kestrel", "Comet", "Sextant",
  "Penumbra", "Ecliptic", "Equinox", "Solstice", "Nadir", "Parallax", "Quadrant", "Vector",
  "Tracer", "Signal", "Relay", "Compass", "Heron", "Owl", "Falcon", "Lynx",
  "Harbour", "Lighthouse", "Fjord", "Ridge", "Watch", "Ember", "Spark", "Drift",
];

const ROMAN = ["", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];

export function drawCodename(random: () => number = Math.random): string {
  const pick = (a: string[]) => a[Math.floor(random() * a.length)];
  return `${pick(FIRST)} ${pick(SECOND)}`;
}

/** The base name (without numeral) if valid, else null. */
export function validBase(name: string): string | null {
  const m = /^([A-Za-z]+) ([A-Za-z]+)(?: [IVX]+)?$/.exec(name.trim());
  if (!m) return null;
  const first = FIRST.find((w) => w.toLowerCase() === m[1].toLowerCase());
  const second = SECOND.find((w) => w.toLowerCase() === m[2].toLowerCase());
  return first && second ? `${first} ${second}` : null;
}

/** "Silent Perigee", then "Silent Perigee II", ... up to XII. */
export function successors(base: string): string[] {
  return ROMAN.map((r) => (r ? `${base} ${r}` : base));
}
